import axios from 'axios';
import config from '../config';
import { showError } from '../utils';

import { store } from '../store';

// Generic network call function to handle common API request patterns
function networkCall({ method, url, headers, params, data, ...extraOptions }) {
  return axios({
    method,
    url,
    headers,
    params,
    data,
    ...extraOptions,
  })
    .then((resp) => {
      const responseBody = resp.data;
      if (
        responseBody.message === 'success' ||
        responseBody.message === 'changeTestType'
      ) {
        return responseBody;
      } else {
        const error = new Error('Invalid response');
        error.data = responseBody;
        throw error;
      }
    })
    .catch((err) => {
      console.log('Errrorrrrrrrrrr', err);
      if (!axios.isCancel(err)) {
        showError(err);
      }
      throw err;
    });
}

export function getLabOrders(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/dashboard-v4?version=${config.v2}`,
    headers,
  });
}

export function getLabTestsCart(authToken, cartId) {
  const headers = {
    authorization: authToken,
  };

  let url = `${config.apiBaseUrl}/labs-v2/cart`;
  if (cartId) {
    url += `/${cartId}`;
  }

  return networkCall({
    method: 'get',
    url,
    headers,
  });
}

export function getLabTests(searchQuery, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/all`,
    headers,
    params: {
      s: searchQuery,
    },
  });
}

export function addLabTest(labId, cartId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/cart/add`,
    headers,
    data: {
      labId,
      cartId,
    },
  });
}

export function uploadPrescription(requestData, onUploadProgress, authToken) {
  console.log('uploadPrescription', requestData);
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs/prescriptions/file`,
    headers,
    data: requestData,
    onUploadProgress,
  });
}

export function removeFileFromPrescription(fileId, prescriptionId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs/prescriptions/file/remove`,
    headers,
    data: {
      fileId,
      prescriptionId,
    },
  });
}

export function removeLabTest(cartItemId, cartId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v3/cart/test/remove`,
    headers,
    data: {
      cartItemId,
      cartId,
    },
  });
}

// export function getLabSlots(authToken) {

//   const headers = {
//     authorization: authToken,
//   };

//   return axios
//     .get(`${config.apiBaseUrl}/labs/slots`, {
//       headers,
//     })
//     .then(resp => {
//       const responseBody = resp.data;
//       if (responseBody.message === 'success') {
//         return responseBody;
//       } else {
//         const err = new Error('Invalid response');
//         err.data = responseBody;
//         showError(err);
//         throw err;
//       }
//     })
//     .catch(err => {
//       showError(err);
//       throw err;
//     });
// }

// !UNUSED
export function selectLabSlot(slotId, date, cartId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs/cart/select-slot`,
    headers,
    data: {
      slotId,
      date,
      cartId,
    },
  });
}

// !UNUSED
export function getSavedAddresses(authToken, cartId) {
  const headers = {
    authorization: authToken,
  };

  let url = `${config.apiBaseUrl}/labs-v2/address`;
  if (cartId) {
    url += `?cartId=${cartId}`;
  }
  return networkCall({
    method: 'get',
    url,
    headers,
  });
}

// !UNUSED
export function getSavedPatients(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs/patients`,
    headers,
  });
}

export function saveNewPatient(patientDetails, authToken) {
  const state = store.getState();
  const headers = {
    authorization: state.user.authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs/patients`,
    headers,
    data: patientDetails,
  });
}

export function saveNewPatientV2(patientDetails, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs/patients`,
    headers,
    data: patientDetails,
  });
}

export function editPatient(patientDetails, authToken) {
  const state = store.getState();
  const headers = {
    authorization: state.user.authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/patients/edit`,
    headers,
    data: patientDetails,
  });
}

export function editPatientV2(patientDetails, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs/patients/edit`,
    headers,
    data: patientDetails,
  });
}

// !UNUSED
export function removePatient(patientId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs/patients/remove`,
    headers,
    data: {
      patientId,
    },
  });
}

export function saveNewAddress(addressDetails, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/address`,
    headers,
    data: addressDetails,
  });
}

export function editAddress(addressDetails, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/address/edit`,
    headers,
    data: addressDetails,
  });
}

export function removeAddress(addressId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/address/remove`,
    headers,
    data: {
      addressId,
    },
  });
}

export function selectPatient(cartId, patientId) {
  const headers = {
    authorization: store.getState().user.authToken,
  };
  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/cart/select-patient`,
    headers,
    data: {
      patientId,
      cartId,
    },
  });
}

export function selectAddress(addressId, cartId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/cart/select-address`,
    headers,
    data: {
      addressId,
      cartId,
    },
  });
}

export function selectSlot(
  slotId,
  cartId,
  date,
  authToken,
  isMondelezAhc = false,
  testType = false
) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/cart/select-slot`,
    headers,
    data: {
      slotId,
      date,
      cartId,
      isMondelezAhc,
      testType,
    },
  });
}

export function getOrderSummaryLabs(cartId, authToken) {
  const currentAddress = JSON.parse(sessionStorage.getItem('selected_address'));
  // const lat = currentAddress?.lat || 0;
  // const long = currentAddress?.lat || 0;
  const { lat = 0, long = 0 } = currentAddress || {};
  let url = `${config.apiBaseUrl}/labs-v3/cart/summary/${cartId}`;
  if (currentAddress) {
    url += `?lat=${lat}&long=${long}`;
  }
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url,
    headers,
  });
}

// !UNUSED
export function getUserPrescriptions(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs/prescriptions`,
    headers,
  });
}

export function payLabCart(
  amount,
  cartId,
  history,
  authToken,
  userConciergePayment
) {
  const headers = {
    authorization: authToken,
  };
  const redirectToPaymentGateway = () => {
    // Not on phonepe in-app or some other error.
    // send to payment
    window.location.assign(
      `${
        config.apiBaseUrl
      }/labs-v2/transact?amount=${amount}&cartId=${cartId}&auth=${
        authToken.split(' ')[1]
      }&isConciergeBooking=${userConciergePayment === true}`
    );
  };
  if (amount === 0) {
    return redirectToPaymentGateway();
  }
  return window.PhonePe.PhonePe.build(window.PhonePe.Constants.Species.web)
    .then((sdk) => {
      // Call the API to fetch the data context
      return axios
        .get(`${config.apiBaseUrl}/labs-v2/transact`, {
          headers,
          params: {
            amount,
            cartId,
            isConciergeBooking: userConciergePayment === true,
          },
        })
        .then((res) => {
          const responseBody = res.data;
          if (responseBody.message === 'success') {
            const context = responseBody.data;
            if (sdk.isMethodSupported('openPaymentsPage')) {
              history.replace('/processing-payment', {
                orderType: 'lab',
                transactionId: responseBody.transactionId,
                successPage: `lab-test/track`,
                failurePage: `lab-test/order-summary`,
                failureStateParameters: {
                  paymentNext: true,
                  cartId: cartId,
                  paymentFailed: true,
                  userConciergePayment,
                },
              });
              return sdk.openPaymentsPage(
                'Visit',
                context,
                `${config.rootUrl}lab-test`,
                'https://getvisitapp.com/img/png/Visit_logo.png',
                [
                  {
                    'Order For': 'Lab Tests',
                  },
                ]
              );
            }
            throw new Error('Phonepe method not supported');
          } else {
            throw new Error('Failed to get payment context');
          }
        });
    })
    .catch((err) => {
      console.log(err);
      try {
        const parsedError = JSON.parse(err);
        if (
          parsedError &&
          (parsedError.error_code === 'PAYMENT_DISMISS' ||
            parsedError.error_code === 'PAYMENT_TIMEOUT')
        ) {
          store.dispatch({
            type: 'SHOW_ERROR',
            payload: {
              errorTitle: 'Something went wrong',
              errorDesc: 'Your payment failed. Please retry your payment.',
            },
          });
          history.push('lab-test/order-summary', {
            cartId,
            paymentNext: true,
            userConciergePayment,
          });
          return;
        }
        // in case of android, it could still be a null error.
        if (parsedError === 'null' || parsedError === null) {
          store.dispatch({
            type: 'SHOW_ERROR',
            payload: {
              errorTitle: 'Something went wrong',
              errorDesc: 'Your payment failed. Please retry your payment.',
            },
          });
          history.push('lab-test/order-summary', {
            cartId,
            paymentNext: true,
            userConciergePayment,
          });
          return;
        }
      } catch (e) {
        //  Since we couldn't parse the error, it means it's not a string and hence not a phonepe dismiss/timeout error.
        // Not on phonepe in-app or some other error.
        // send to payment
        redirectToPaymentGateway();
      }
    });
}

// !UNUSED
export function getTranscriptionPreSubmitSummary(
  prescriptionId,
  patientId,
  addressId,
  slotId,
  collectionDate,
  authToken
) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs/transcription/pre-submit`,
    headers,
    data: {
      prescriptionId,
      patientId,
      addressId,
      slotId,
      collectionDate,
    },
  });
}

// !UNUSED
export function submitForTranscription(
  prescriptionId,
  patientId,
  addressId,
  slotId,
  collectionDate,
  authToken
) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs/prescriptions/submit-request`,
    headers,
    data: {
      prescriptionId,
      patientId,
      addressId,
      slotId,
      collectionDate,
    },
  });
}

// !UNUSED
export function getTranscriptionStatus(prescriptionId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs/transcription/request/${prescriptionId}`,
    headers,
  });
}

export function getOrderStatus(orderId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs/order/status/${orderId}`,
    headers,
  });
}

// !UNUSED
export function verifyPincode(pincode, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs/pincode/check`,
    headers,
    params: {
      pincode,
    },
  });
}

export function fetchPrescription(prescriptionId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs/prescriptions/${prescriptionId}`,
    headers,
  });
}
// !UNUSED
export function getVisitPresciptions(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs/online/prescriptions`,
    headers,
  });
}

// !UNUSED
export function searchCities(searchQuery, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs/cities`,
    headers,
    params: {
      s: searchQuery,
    },
  });
}

export function autoSuggestLocation(searchQuery, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/location/auto-suggest`,
    headers,
    params: {
      q: searchQuery,
    },
  });
}

export function trackLabOrder(transactionId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs/phonepe/transaction/status/${transactionId}`,
    headers,
  });
}

export function fetchLabOrderDetail(orderId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/order/${orderId}`,
    headers,
  });
}

export function getDigitsationStatus(digitisationId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/digitisation/${digitisationId}`,
    headers,
  });
}

export function getAllLabsOrder(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/orders-v2`,
    headers,
  });
}

export function getOrderHistory(authToken, type, page, signal) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/order-history?type=${type}&page=${page}&size=10`,
    headers,
    signal,
  });
}

export function refundStatusLabs(orderId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/cancel-order-details?orderId=${orderId}`,
    headers,
  });
}

export function submitDigitsationRequest(
  prescriptionId,
  addressId,
  authToken,
  patientId
) {
  console.log('submitDigitsationRequest', prescriptionId, addressId, authToken);
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/digitisation/submit-request`,
    headers,
    data: {
      prescriptionId,
      addressId,
      patientId,
    },
  });
}

export function existingPrescriptionDigitsationRequest(
  consultationId,
  medsPrescriptionId,
  offlinePrescriptionId,
  authToken,
  addressId
) {
  let body = {
    consultationId,
    addressId,
  };
  if (medsPrescriptionId) {
    body = { ...body, medsPrescriptionId };
  } else if (offlinePrescriptionId) {
    body = { ...body, offlinePrescriptionId };
  }
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/digitisation/select-lab-prescription`,
    headers,
    data: body,
  });
}

export function getLabs(cartId, lat, long, authToken, filter) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${
      config.apiBaseUrl
    }/labs-v3/cart/partners/${cartId}?lat=${lat}&long=${long}${
      filter ? `&filter=${filter}` : ''
    }`,
    headers,
  });
}

export function selectLabPartner(
  cartId,
  partnerId,
  meta,
  authToken,
  isMondelezAhc,
  testsType
) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/cart/select-partner`,
    headers,
    data: {
      cartId,
      partnerId,
      meta,
      isMondelezAhc,
      testsType,
    },
  });
}

export function getLabSlots(cartId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/slots?cartId=${cartId}`,
    headers,
  });
}

export function getAddress(authToken, cartId = null) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/address${
      cartId ? `?cartId=${cartId}` : ''
    }`,
    headers,
  });
}

export function getPatients(
  authToken,
  type,
  cartId = null,
  packageId = null,
  isConciergeBooking = null
) {
  const state = store.getState();
  const headers = {
    authorization: state.user.authToken,
  };
  const queryParams = new URLSearchParams();
  if (type) {
    queryParams.append('type', type);
  }
  if (cartId) {
    queryParams.append('cartId', cartId);
  }
  if (packageId) {
    queryParams.append('packageId', packageId);
  }
  if (isConciergeBooking) {
    queryParams.append('isConciergeBooking', true);
  }
  console.log(queryParams.toString());

  const url = `${config.apiBaseUrl}/labs-v2/patients?${queryParams.toString()}`;

  return networkCall({
    method: 'get',
    url,
    headers,
  });
}

export function reimbursementSubmitLabs(cartId, patientId, date, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/reimburse/submit`,
    headers,
    data: {
      cartId,
      patientId,
      date,
    },
  });
}

export function reimbursementDetails(reimbursementId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/reimburse/details/${reimbursementId}`,
    headers,
  });
}

export function reimbursementInvoiceSubmit(formData, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/reimbursements/invoice`,
    headers,
    data: formData,
  });
}

export function bookAhcRequest(patientId, addressId, preferredDate, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/ahc/add-request`,
    headers,
    data: {
      patientId,
      addressId,
      preferredDate,
    },
  });
}

export function getAhcRequestForUser(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/get-request-for-user`,
    headers,
  });
}

// !UNUSED
export function fetchCopayOrderDetail(orderId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/copay/checkout?orderId=${orderId}`,
    headers,
  });
}

export function payLabCopay(orderId, history, authToken) {
  const headers = {
    authorization: authToken,
  };
  const redirectToPaymentGateway = () => {
    // Not on phonepe in-app or some other error.
    // send to payment
    window.location.assign(
      `${config.apiBaseUrl}/labs-v2/copay/transact?orderId=${orderId}&auth=${
        authToken.split(' ')[1]
      }`
    );
  };

  return window.PhonePe.PhonePe.build(window.PhonePe.Constants.Species.web)
    .then((sdk) => {
      // Call the API to fetch the data context
      return axios
        .get(`${config.apiBaseUrl}/labs-v2/copay/transact`, {
          headers,
          params: {
            orderId,
          },
        })
        .then((res) => {
          const responseBody = res.data;
          if (responseBody.message === 'success') {
            const context = responseBody.data;
            if (sdk.isMethodSupported('openPaymentsPage')) {
              history.replace('/processing-payment', {
                orderType: 'lab',
                transactionId: responseBody.transactionId,
                successPage: `lab-test/track`,
                failurePage: `lab-test/copay`,
                failureStateParameters: {
                  paymentNext: true,
                },
              });
              return sdk.openPaymentsPage(
                'Visit',
                context,
                `${config.rootUrl}lab-test`,
                'https://getvisitapp.com/img/png/Visit_logo.png',
                [
                  {
                    'Order For': 'Lab Tests',
                  },
                ]
              );
            }
            throw new Error('Phonepe method not supported');
          } else {
            throw new Error('Failed to get payment context');
          }
        });
    })
    .catch((err) => {
      console.log(err);
      try {
        const parsedError = JSON.parse(err);
        if (
          parsedError &&
          (parsedError.error_code === 'PAYMENT_DISMISS' ||
            parsedError.error_code === 'PAYMENT_TIMEOUT')
        ) {
          store.dispatch({
            type: 'SHOW_ERROR',
            payload: {
              errorTitle: 'Something went wrong',
              errorDesc: 'Your payment failed. Please retry your payment.',
            },
          });
          history.push('lab-test/copay', {
            orderId,
            paymentNext: true,
          });
          return;
        }
        // in case of android, it could still be a null error.
        if (parsedError === 'null' || parsedError === null) {
          store.dispatch({
            type: 'SHOW_ERROR',
            payload: {
              errorTitle: 'Something went wrong',
              errorDesc: 'Your payment failed. Please retry your payment.',
            },
          });
          history.push('lab-test/copay', {
            orderId,
            paymentNext: true,
          });
          return;
        }
      } catch (e) {
        //  Since we couldn't parse the error, it means it's not a string and hence not a phonepe dismiss/timeout error.
        // Not on phonepe in-app or some other error.
        // send to payment
        redirectToPaymentGateway();
      }
    });
}

export function getSuezAhcPackage(patientId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/suez?patientId=${patientId}`,
    headers,
  });
}

export function getMcdermottAhcPackage(patientId, testType, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/mcdermott?patientId=${patientId}&testType=${testType}`,
    headers,
  });
}

export function getOracleAhcPackage(patientId, testType, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/oracle`,
    headers,
    params: {
      patientId,
      testType,
    },
  });
}

export function getMondelezRevampAhcPackage(patientId, testType, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/mondelez-revamp`,
    headers,
    params: {
      patientId,
      testType,
    },
  });
}

export function getUniversalAhcPackage(patientId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/universal`,
    headers,
    params: {
      patientId,
    },
  });
}

export function getHitachiAhcPackage(patientId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/hitachi`,
    headers,
    params: {
      patientId,
    },
  });
}

export function getValmetAhcPackage(patientId, testType, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/valmet`,
    headers,
    params: {
      patientId,
      testType,
    },
  });
}

export function getMondelenzeAhcPackage(
  patientId,
  isPathologyAdded,
  noTmt,
  authToken
) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/mondelez`,
    headers,
    params: {
      patientId,
      isPathologyAdded,
      noTmt,
    },
  });
}

export function getBiracAhcPackage(patientId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/birac`,
    headers,
    params: {
      patientId,
    },
  });
}

export function getEqualExpertsAhcPackage(patientId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/equal-experts`,
    headers,
    params: {
      patientId,
    },
  });
}

export function getHindalcoAhcPackage(patientId, testType, authToken, self) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/hindalco`,
    headers,
    params: {
      patientId,
      testType,
      self,
    },
  });
}

export function bookAhcForMondelez(authToken) {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/book-mondelez-ahc`,
    headers,
    data: null,
  });
}

export function get3MAhcPackage(patientId, testType, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/3m`,
    headers,
    params: {
      patientId,
      testType,
    },
  });
}

export function getWomensDayPackage(testType, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/womensDay`,
    headers,
    params: {
      testType,
    },
  });
}

export function getDream11AhcPackage(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/dream11`,
    headers,
  });
}

export function getIndigridAhcPackage(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/indigrid`,
    headers,
  });
}

export function getPackageLeadsDetails(authToken, packageId) {
  const headers = {
    authorization: authToken,
  };
  console.log('getPackageLeadsDetails', authToken, packageId);
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/packagesLead/${packageId}`,
    headers,
  });
}

export function getAxisAhcPackage(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/axis`,
    headers,
  });
}

export function getBacardiAhcPackage(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/bacardi`,
    headers,
  });
}

export function get8spadesAhcPackage(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/8spades`,
    headers,
  });
}

export function getO9AhcPackage(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/o9`,
    headers,
  });
}

export function getAuAhcPackage(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/au`,
    headers,
  });
}

export function getAegonPackage(patientId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/aegon`,
    headers,
    params: {
      patientId,
    },
  });
}

export function getJNJAhcPackage(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/jnj`,
    headers,
  });
}

export function getSelAhcPackage(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/sel`,
    headers,
  });
}

export function getAhcPartners(authToken, lat, long) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/list-partners`,
    headers,
    params: {
      lat,
      long,
    },
  });
}

// !UNUSED
export function bookAhcOrder(
  patientId,
  preferredDate,
  partnerId,
  centerId,
  authToken
) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/ahc/book-order`,
    headers,
    data: {
      patientId,
      partnerId,
      centerId,
      collectionDate: preferredDate,
    },
  });
}

export function packageDetails(packageId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/package-details`,
    headers,
    params: {
      packageId,
    },
  });
}

export function addPackageToCart(cartId, packageId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/cart/add`,
    headers,
    data: {
      cartId,
      packageId,
    },
  });
}

export function addAddonToCart(cartId, addOnTestId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/cart/add`,
    headers,
    data: {
      addOnTestId,
      cartId,
    },
  });
}

// !UNUSED
export function getBottomCartText(cartId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/labs-v2/cart/summary/${cartId}?bottomCart=1`, {
      headers,
    })
    .then((resp) => {
      console.log(resp);
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        if (
          responseBody &&
          responseBody.errorMessage ===
            "Cannot read property 'partnerId' of undefined"
        ) {
          responseBody.page = 'lab-select';
          return responseBody;
        }
        const err = new Error('Invalid response');
        err.data = responseBody;
        showError(err);
        throw err;
      }
    })
    .catch((err) => {
      console.log(err);
      if (
        err &&
        err.response &&
        err.response.data &&
        (err.response.data.errorMessage ===
          "Cannot read property 'partnerId' of undefined" ||
          err.response.data.errorMessage === 'Address details not selected' ||
          err.response.data.errorMessage === 'Patient details not selected')
      ) {
        return { page: 'lab-select' };
      }
      showError(err);
      throw err;
    });
}

export function fetchLabsSamplePrescription(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/upload-prescription/details`,
    headers,
  });
}

export function deleteCart(cartId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/remove-cart/${cartId}`,
    headers,
    data: null,
  });
}

export function uploadAddressProof(
  requestData,
  onUploadProgress,
  cartId,
  authToken
) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/upload/address-proof/${cartId}`,
    headers,
    data: requestData,
    onUploadProgress,
  });
}

export function deleteAddressProof(url, cartId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/delete/address-proof/${cartId}`,
    headers,
    data: {
      url,
    },
  });
}

export function fetchAllAddressProofFile(cartId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/address-proof/${cartId}`,
    headers,
  });
}

export function getCovidDashboard(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/covid-dashboard`,
    headers,
  });
}

export function getPackagesLead(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/packagesLead`,
    headers,
  });
}

export function covidPackageDetails(id, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/covid-test/${id}`,
    headers,
  });
}

export function getCovidHomeCareDashboard(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/subscription/covid-home-care-dashboard`,
    headers,
  });
}

export function markSamplePickedUp(orderId, samplePickup, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/order/sample-pickup`,
    headers,
    data: {
      orderId,
      samplePickup,
    },
  });
}

export function covidDeclaration(body, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/covid-test-result`,
    headers,
    data: body,
  });
}

export function submitAhcReimbursementRequest(
  requestData,
  onUploadProgress,
  authToken
) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/ahc/create-reimbursement-request`,
    headers,
    data: requestData,
    onUploadProgress,
  });
}

export function getAhcParentalRelatives() {
  const state = store.getState();
  const headers = {
    authorization: state.user.authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/parental/patients`,
    headers,
  });
}

export function addAhcParentRelative(name, dob, gender, phone, relationId) {
  const state = store.getState();
  const headers = {
    authorization: state.user.authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/ahc/parental/patients`,
    headers,
    data: {
      name,
      dob,
      gender,
      phone,
      relationId,
    },
  });
}

export function hindalcoSaveConsent(consentResponse) {
  console.log({ consentResponse }, '[hindalcoSaveConsent]');
  const state = store.getState();
  const headers = {
    authorization: state.user.authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/ahc/hindalco/consent-response`,
    headers,
    data: {
      consentResponse,
    },
  });
}

export function addInfoedgeAhcToCart(cartId) {
  const state = store.getState();
  const headers = {
    authorization: state.user.authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/infoedge/addParentalAHCToCart`,
    headers,
    data: {
      cartId,
    },
  });
}

export function addDream11AhcToCart(cartId) {
  const state = store.getState();
  const headers = {
    authorization: state.user.authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/dream11/addAHCTestToCart`,
    headers,
    data: {
      cartId,
    },
  });
}

export function addGartnerAhcToCart(cartId) {
  const state = store.getState();
  const headers = {
    authorization: state.user.authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/gartner/addAHCTestToCart`,
    headers,
    data: {
      cartId,
    },
  });
}

export function addO9AhcToCart(cartId) {
  const state = store.getState();
  const headers = {
    authorization: state.user.authToken,
  };

  const requestData = {
    cartId,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/O9/addAHCTestToCart`,
    headers,
    data: requestData,
  });
}

export function addAuAhcToCart(cartId) {
  const state = store.getState();
  const headers = {
    authorization: state.user.authToken,
  };

  const requestData = {
    cartId,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/au/addAHCTestToCart`,
    headers,
    data: requestData,
  });
}

export function addIndigridAhcToCart(cartId) {
  const state = store.getState();
  const headers = {
    authorization: state.user.authToken,
  };

  const requestData = {
    cartId,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/indigrid/addAHCTestToCart`,
    headers,
    data: requestData,
  });
}

export function addAxisAhcToCart(cartId, testId) {
  const state = store.getState();
  const headers = {
    authorization: state.user.authToken,
  };

  const requestData = {
    cartId,
    testId,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/axis/addAHCTestToCart`,
    headers,
    data: requestData,
  });
}

export function addBacardiAhcToCart(cartId, testId) {
  const state = store.getState();
  const headers = {
    authorization: state.user.authToken,
  };

  const requestData = {
    cartId,
    testId,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/bacardi/addAHCTestToCart`,
    headers,
    data: requestData,
  });
}

export function addJNJAhcToCart(cartId, testId) {
  const state = store.getState();
  const headers = {
    authorization: state.user.authToken,
  };

  const requestData = {
    cartId,
    testId,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/jnj/addAHCTestToCart`,
    headers,
    data: requestData,
  });
}

export function addSelAhcToCart(cartId) {
  const state = store.getState();
  const headers = {
    authorization: state.user.authToken,
  };

  const requestData = {
    cartId,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/sel/addAHCTestToCart`,
    headers,
    data: requestData,
  });
}

export function addCanaraHSBCAhcToCart(cartId, testId) {
  const state = store.getState();
  const headers = {
    authorization: state.user.authToken,
  };

  const requestData = {
    testId,
    cartId,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/canaraHSBC/addAHCTestToCart`,
    headers,
    data: requestData,
  });
}

export function addAegonAhcToCart(cartId, packageId) {
  const state = store.getState();
  const headers = {
    authorization: state.user.authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/aegon/aegonAHCTestToCart`,
    headers,
    data: {
      packageId,
      cartId,
    },
  });
}

export function addMcdermottAhcToCart(
  cartId,
  packageId,
  testType,
  packageTestMapIds
) {
  const state = store.getState();
  const headers = {
    authorization: state.user.authToken,
  };

  if (testType === 'radiology tmt') {
    testType = 'radiology';
  }

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/mcdermott/addAHCTestToCart`,
    headers,
    data: {
      packageId,
      cartId,
      testType,
      packageTestMapIds,
    },
  });
}

export function addPhysicswallahAhcToCart(cartId, packageId, testType) {
  const state = store.getState();
  const headers = {
    authorization: state.user.authToken,
  };

  if (testType === 'radiology tmt') {
    testType = 'radiology';
  }

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/physicswallah/addAHCTestToCart`,
    headers,
    data: {
      packageId,
      cartId,
      testType,
    },
  });
}

export function getCanaraHSBCAhcPackage(patientId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/canarahsbc`,
    headers,
    params: {
      patientId,
    },
  });
}

export function getAngloAhcPackage(patientId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/anglo`,
    headers,
    params: {
      patientId,
    },
  });
}

export function getAecAhcPackage(patientId, testsType, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/ahc/aec`,
    headers,
    params: {
      patientId,
      testsType,
    },
  });
}

export function getCitiesListForIsolationCenters(authToken) {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/isolation-centers/cities`,
    headers,
  });
}

export function getIsolationCentersListForACity(authToken, lat, long, city) {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/isolation-centers/centers`,
    headers,
    params: {
      lat,
      long,
      city,
    },
  });
}

export function getDetailsOfAParticularCenter(authToken, centerId, lat, long) {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/isolation-centers/center-details`,
    headers,
    params: {
      lat,
      long,
      centerId,
    },
  });
}

export function placeBookingRequest(authToken, body) {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/isolation-centers/book-request`,
    headers,
    data: body,
  });
}

export function getBookingStatus(authToken, id) {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/isolation-centers/booking-status`,
    headers,
    params: {
      requestId: id,
    },
  });
}

export function getAllPreviousBookings(authToken) {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/isolation-centers/previous-bookings`,
    headers,
  });
}

export function crosswordStart(authToken, puzzleId) {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/crossword/crossword-start`,
    headers,
    data: { puzzleId },
  });
}

export function getCrossword(authToken, puzzleId) {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/crossword/get-crossword`,
    headers,
    params: {
      crosswordId: puzzleId,
    },
  });
}

export function crosswordSubmit(authToken, sessionId, puzzleId) {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/crossword/submit-crossword`,
    headers,
    data: { sessionId, puzzleId },
  });
}

export function getCrosswordPuzzleData(authToken, puzzleId) {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/crossword/get-crossword-id`,
    headers,
    params: {
      puzzleId,
    },
  });
}

export function intitiateEmergencyCall(authToken, orderId) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/order/initiate-call-by-user`,
    headers,
    data: { orderId },
  }).then((responseBody) =>
    responseBody.message === 'SUCCESS' ? responseBody.showMessage : responseBody
  );
}

export const sendAHCLeadRequestToPPMC = (authToken, packageId) => {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/new-ops/ahc/ahc-leads/request-lead`,
    headers,
    data: { packageId },
  });
};
export const getLabOrdersTimeline = (
  authToken,
  orderId,
  digitisationId,
  cartId
) => {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/dashboard-timeline-v2`,
    headers,
    params: {
      dRequestId: digitisationId ? digitisationId : 0,
      orderId: orderId ? orderId : 0,
      cartId: cartId ? cartId : 0,
    },
  });
};

export const postSamplePickup = (authToken, isAllowed, orderId) => {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/order/sample-pickup`,
    headers,
    data: {
      samplePickup: isAllowed,
      orderId,
    },
  });
};

export const copay = (authToken, orderId) => {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/copay/transact`,
    headers,
    params: {
      orderId,
    },
  });
};

export const submitFeedback = (
  authToken,
  text,
  event,
  orderId,
  rating,
  reason
) => {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/submit-feedback`,
    headers,
    data: {
      text,
      event,
      orderId,
      rating,
      reason,
    },
  });
};

export function reasonsForCancelletion(authToken, centerVisit) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/cancel-reason-for-users`,
    headers,
    params: {
      isCenterVisit: centerVisit,
    },
  });
}

export function cancelLabOrders(authToken, cancelDetails, orderId) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/change-status-by-user`,
    headers,
    data: {
      orderId,
      cancelDetails,
      status: 'order-cancelled',
    },
  });
}

export function reasonsForCancelletionNew(authToken, centerVisit, orderId) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/cancel-reason-for-users-new`,
    headers,
    params: {
      isCenterVisit: centerVisit,
      orderId,
    },
  });
}

export function checkBenefitsAvailable(authToken, staffId) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/new-auth/check-benefits`,
    headers,
    data: {
      staffId,
    },
  });
}

export function checkBenefitActivated(authToken, submitID) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/new-auth/check-benefit-activated`,
    headers,
    params: {
      submitId: submitID,
    },
  });
}

export function getOnlinePrescriptionList(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/opd/consult/get-online-consults-with-prescriptions`,
    headers,
  });
}
export function getOfflineOfflinePrescriptionList(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/care/offline-consult-med-labs`,
    headers,
  });
}

export function addExisitingPrescription(authToken, filesURLArray) {
  console.log('filesURLArray', filesURLArray);
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs/prescriptions/add-files`,
    headers,
    data: { filesURLArray },
  });
}

export function getSmartReportDetails(authToken, caseId, filter, search) {
  const headers = {
    authorization: authToken,
  };

  const queryParams = new URLSearchParams();
  if (caseId) {
    queryParams.append('applicationId', caseId);
  }
  if (filter) {
    queryParams.append('filter', filter);
  }
  if (search) {
    queryParams.append('search', search);
  }
  return networkCall({
    method: 'get',
    url: `${
      config.ppmcServer
    }/smart-report/v3/get-smart-summary?${queryParams.toString()}`,
    headers,
  });
}

export const getDetailedSmartReport = (authToken, caseId, profileName) => {
  const headers = {
    authorization: authToken,
  };
  const queryParams = new URLSearchParams();
  if (caseId) {
    queryParams.append('applicationId', caseId);
  }
  if (profileName) {
    queryParams.append('profileName', profileName);
  }
  return networkCall({
    method: 'get',
    url: `${
      config.ppmcServer
    }/smart-report/v3/get-smart-summary-for-profile?${queryParams.toString()}`,
    headers,
  });
};

export const checkForSmartReport = (authToken, caseId) => {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'get',
    url: `${config.ppmcServer}/smart-report/check-if-smart-summary-available?applicationId=${caseId}`,
    headers,
  });
};

export const getSmartSummaryFeedback = (authToken, caseId) => {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'get',
    url: `${config.ppmcServer}/smart-report/get-smart-summary-feedback?applicationId=${caseId}`,
    headers,
  });
};

export function getAllDigitisationQuery(authToken, digitisationId) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/digitisation/get-all-digitisation-query/${digitisationId}`,
    headers,
  });
}

export const postSmartSummaryFeedback = (
  authToken,
  applicationId,
  rating,
  feedbackText
) => {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'post',
    url: `${config.ppmcServer}/smart-report/add-smart-summary-feedback`,
    headers,
    data: { applicationId, rating, feedbackText },
  });
};

export function getAllDigitisationQueryHistoryLabs(authToken, digitisationId) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/digitisation/get-digitisation-query-history/${digitisationId}`,
    headers,
  });
}

export function uploadLabsDocuments(authToken, body) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs/prescriptions/file`,
    headers,
    data: body,
  });
}

export function removeDocumentLabs(authToken, body) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs/prescriptions/file/remove`,
    headers,
    data: body,
  });
}

export function sumbitDoc(authToken, body) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/digitisation/submit-request`,
    headers,
    data: body,
  });
}

export function submitConsent(authToken, body) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/update-order-consent`,
    headers,
    data: body,
  });
}

export function getAllAhcPackages(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/labs-v2/view-all-packages`,
    headers,
  });
}

//NSA
export const addAHCRequestToNSA = (authToken, addressId, cartId, packageId) => {
  const headers = {
    authorization: authToken,
  };
  return axios
    .post(
      `${config.apiBaseUrl}/labs-v2/add-ahc-request-to-nsa`,
      { addressId, cartId, packageId },
      {
        headers,
      }
    )
    .then((response) => {
      const responseBody = response.data;
      return responseBody;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
};

export const findingLabPartner = (authToken, requestId = 26) => {
  const headers = {
    authorization: authToken,
  };
  return axios
    .get(
      `${config.apiBaseUrl}/labs-v2/finding-lab-partner?requestId=${requestId}`,
      {
        headers,
      }
    )
    .then((res) => {
      const responseBody = res.data;
      return responseBody;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
};

export const getUserRelations = (authToken) => {
  const headers = {
    authorization: authToken,
  };
  return axios
    .get(`${config.apiBaseUrl}/labs-v3/get-user-relations`, {
      headers,
    })
    .then((res) => {
      const responseBody = res.data;
      return responseBody;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
};
